import React from "react";
import InterestPageBooks from "./InterestPageBooks/InterestPageBooks";
import QAForm from "./QAForm";
import InterestPageHeader from "./InterestPageHeader";
import { useAppContext } from "@components/Provider";

const InterestPage = (props) => {
  const { data } = props;
  const post = data[0]?.Post?.post;
  const { subscriberCookie, isMobile, isTablet } = useAppContext();
  const renderInterestPageComps = () => (
    <React.Fragment>
      <InterestPageHeader
        {...post.components.filter((el) => el && el?.type === "interest-page-config")[0]}
        siteID={props.siteId}
        bisacs={post.bisacs}
        isMobile={isMobile}
        title={post.title}
      />
      <InterestPageBooks
        {...props}
        books={[
          ...(post.components.filter((el) => el && el?.type === "interest-page-books")[0]?.props ||
            []),
        ]}
        newsletterProps={{
          ...(post.components.filter((el) => el && el?.type === "newsletter-v2")[0]?.props || {}),
        }}
        isMobile={isMobile}
        isTablet={isTablet}
        subscriberCookie={subscriberCookie}
      />
      <QAForm
        {...(post.components.filter((el) => el && el?.type === "qa-form")[0] || {})}
        isMobile={isMobile}
        isTablet={isTablet}
      />
    </React.Fragment>
  );
  return (
    <div className="interest-page">
      {renderInterestPageComps()}
      <style jsx>
        {`
          // .interest-page {
          //   padding-top: ${!subscriberCookie && isMobile ? "15%" : "3%"};
          // }
          @media (max-width: 768px) {
            .interest-page {
              width: auto;
            }
          }
        `}
      </style>
    </div>
  );
};

export default InterestPage;
